import React from 'react';
import LockClosedFilledIcon from '@assets/icons/modal/alert1.svg';
import { BaseButton, BaseModal } from '@components';
import { useLingui } from '@lingui/react/macro';
import { ModalHeader as Header, ModalTopSection as TopSection } from '@routes/___shared___/styled.tsx';
import { AlertSection } from '@routes/auth/___shared___/styled.tsx';

import { BaseButtonTitle, ModalButtonsWrapper as ButtonsWrapper, modalForceStyles } from '../styled.ts';

interface Props {
    open: boolean;
    closeIcon: React.ReactNode;
    setIsOpen: (isOpen: boolean) => void;
    onConfirmDelete: () => void;
    isSubmitOk: boolean;
    isLoading: boolean;
    submitDate: string;
    requestId: string;
}

const Modal: React.FC<Props> = ({
    open,
    closeIcon,
    setIsOpen,
    onConfirmDelete,
    isSubmitOk,
    isLoading,
    submitDate,
    requestId,
}) => {
    const { t } = useLingui();
    const HEADER_DELETE = t`Do you want your personal data to be deleted?`;
    const HEADER_INFO = t`Data deletion request submitted`;
    const MSG_DELETE = t`If you continue, all your personal data will be permanently deleted. This action cannot be undone. Are you sure you want to proceed?`;
    const MSG_INFO = t`Your request to delete data has been successfully submitted. You will receive a confirmation email once the process is complete.`;

    const handleSubmit = () => {
        onConfirmDelete();
    };

    return (
        <BaseModal
            closeIcon={closeIcon}
            open={open}
            title={
                <TopSection>
                    <LockClosedFilledIcon />
                    <Header>{isSubmitOk ? HEADER_INFO : HEADER_DELETE}</Header>
                </TopSection>
            }
            styles={{ mask: modalForceStyles.mask }}
            content={
                <>
                    <AlertSection>
                        {isSubmitOk ? (
                            <AlertSection>
                                <div>{MSG_INFO}</div>
                                <br />
                                <div>
                                    {t`Request ID`}: {requestId}
                                </div>
                                <br />
                                <div>
                                    {t`Submitted on`}: {submitDate}
                                </div>
                            </AlertSection>
                        ) : (
                            MSG_DELETE
                        )}
                    </AlertSection>
                    <ButtonsWrapper>
                        {isSubmitOk ? (
                            <BaseButton $customType="primary" onClick={() => setIsOpen(false)}>
                                <BaseButtonTitle>{t`Close`}</BaseButtonTitle>
                            </BaseButton>
                        ) : (
                            <>
                                <BaseButton
                                    id={'confirm-del-btn'}
                                    loading={isLoading}
                                    $customType="outline"
                                    onClick={handleSubmit}
                                >
                                    <BaseButtonTitle>{t`Yes, delete data`}</BaseButtonTitle>
                                </BaseButton>
                                <BaseButton $customType="primary" onClick={() => setIsOpen(false)}>
                                    <BaseButtonTitle>{t`Cancel`}</BaseButtonTitle>
                                </BaseButton>
                            </>
                        )}
                    </ButtonsWrapper>
                </>
            }
            footer={null}
        />
    );
};

export default Modal;
